import React from "react";
import { getInitials } from "../../utilities/helpers";
import { formatDateReadable } from "../../utilities/helpers";
import EmptyState from "../../shared/helpers/EmptyState";
import ActionPill from "./ActionPill";
import ShiftPoolApprovedDrawer from "./ShiftPoolApprovedDrawer";
import { get_t_str } from "../../../../../helpers/helpers";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

export default function ShiftPoolApprovedTable(props) {
  // Add safety check for props and requestResponsesData
  const requestResponsesData2 = props.requestResponsesData2?.shift_change_request_history || [];

  let shiftPoolHistory = requestResponsesData2.filter((v, i) => v?.shift_pickup_json === null)

  console.log("SHIFT POOL HISTORY", shiftPoolHistory)

  // New state for drawer
  const [isDrawerOpen, setDrawerOpen] = React.useState(false);
  const [selectedShift, setSelectedShift] = React.useState(null);

  // Status display function
  const getActionDisplay = (shift) => {
    const status = shift?.type;
    const employeePickup = shift?.employee_pickup;

    switch (status) {
      case 'drop_accepted':
        if (employeePickup?.first_name && employeePickup?.last_name) {
          return {
            text: `Assigned to ${employeePickup.first_name} ${employeePickup.last_name}`,
            textColor: 'text-emerald-800',
            bgColor: 'bg-emerald-100'
          };
        }
        return {
          text: 'Drop Accepted',
          textColor: 'text-emerald-800',
          bgColor: 'bg-emerald-100'
        };

      case 'drop_rejected':
        return {
          text: 'Drop Rejected',
          textColor: 'text-red-800',
          bgColor: 'bg-red-100'
        };

      case 'drop_to_deleted':
        return {
          text: 'Shift Deleted',
          textColor: 'text-slate-800',
          bgColor: 'bg-slate-100'
        };

      case 'drop_to_open_shift':
        return {
          text: 'Converted to Open Shift',
          textColor: 'text-blue-800',
          bgColor: 'bg-blue-100'
        };

      case 'open_shift':
        if (employeePickup?.first_name && employeePickup?.last_name) {
          return {
            text: `Assigned to ${employeePickup.first_name} ${employeePickup.last_name}`,
            textColor: 'text-emerald-800',
            bgColor: 'bg-emerald-100'
          };
        }
        return {
          text: 'Open Shift',
          textColor: 'text-blue-800',
          bgColor: 'bg-blue-100'
        };

      default:
        return {
          text: 'Pending',
          textColor: 'text-yellow-800',
          bgColor: 'bg-yellow-100'
      };
    }
  };

  const handleRowClick = (shift) => {
    // Format the shift info to match what the drawer expects
    const shiftInfo = {
      firstName: shift?.employee_drop?.first_name || '',
      lastName: shift?.employee_drop?.last_name || '',
      date: shift?.shift_drop_json?.date || '',
      shift: `${get_t_str(shift?.shift_drop_json?.shift_start)} - ${get_t_str(shift?.shift_drop_json?.shift_end)}` || '',
      break:
        shift?.shift_drop_json?.break_length > 0 ||
        (shift?.shift_drop_json?.break_length_2 || 0) > 0
          ? [
              shift?.shift_drop_json?.break_length > 0
                ? `${get_t_str(shift?.shift_drop_json?.break_start)} (${shift?.shift_drop_json?.break_length}hrs)`
                : null,
              (shift?.shift_drop_json?.break_length_2 || 0) > 0
                ? `${get_t_str(shift?.shift_drop_json?.break_start_2)} (${shift?.shift_drop_json?.break_length_2}hrs)`
                : null,
            ]
              .filter(Boolean)
              .join(", ")
          : "No break",
      station: shift?.shift_drop_json?.station?.name || '',
      role: shift?.shift_drop_json?.role_id?.role_name || '',
      roleType: shift?.shift_drop_json?.role_id?.role_type?.role_type || '',
      location: props.requestResponsesData2?.store?.store_name || '',
      status: shift?.type || '',
      dateResponded: shift?.created_at,
      actedBy: shift?.acting_manager_name || null,
      employeePickup: shift?.employee_pickup || null,
      employeeRejectedList: shift?.employee_rejected_list || []
    };

    const drawerData = {
      shiftInfo,
      note: shift?.note,
      employeeDropNote: shift?.employee_drop_note,
    };

    setSelectedShift(drawerData);
    setDrawerOpen(true);
  };

  const handleArchiveClick = (e, shiftUuid) => {
    e.stopPropagation(); // Prevent row click
    if (props?.archive_shift_pickup_request && shiftUuid) {
      props.archive_shift_pickup_request(shiftUuid);
    }
  };

  return (
    <>
      <div className="mt-12">
        {shiftPoolHistory.length > 0 ? (
          <div>
            <div className="flex items-center px-6">
              <div className="flex-auto">
                <h1 className="text-xl font-bold text-slate-900">History</h1>
              </div>
            </div>
            <div className="mt-8 flex flex-col">
              <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 min-w-full">
                <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <table className="min-w-full divide-y divide-slate-100">
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            className="w-[20%] py-3 pl-6 pr-3 text-left text-xs font-semibold text-slate-500"
                          >
                            Type
                          </th>
                          <th
                            scope="col"
                            className="w-[20%] px-3 py-3 text-left text-xs font-semibold text-slate-500"
                          >
                            Shift
                          </th>
                          <th
                            scope="col"
                            className="w-[20%] px-3 py-3 text-left text-xs font-semibold text-slate-500"
                          >
                            Role
                          </th>
                          <th
                            scope="col"
                            className="w-[20%] px-3 py-3 text-left text-xs font-semibold text-slate-500"
                          >
                            Action
                          </th>
                          <th
                            scope="col"
                            className="w-1/12 relative py-3 pl-3 pr-6"
                          >
                            <span className="sr-only">Actions</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100 bg-white">
                        {shiftPoolHistory?.map((shift, index) => {
                          const shiftDrop = shift?.shift_drop_json || {};

                          return (
                            <tr
                              key={shift?.uuid || index}
                              className="hover:bg-slate-50 cursor-pointer transition-colors"
                              onClick={() => handleRowClick(shift)}
                            >
                              <td className="whitespace-nowrap py-3.5 pl-6 pr-3 text-sm">
                                <div className="flex items-center space-x-2">
                                  <div
                                    className={`${
                                      shift.type === "open_shift"
                                        ? "text-emerald-600"
                                        : "text-rose-600"
                                    }`}
                                  >
                                    {shift.type === "open_shift" ? (
                                      <AddCircleIcon sx={{ fontSize: 14 }} />
                                    ) : (
                                      <RemoveCircleIcon sx={{ fontSize: 14 }} />
                                    )}
                                  </div>
                                  <div
                                    className={`font-semibold text-sm ${
                                      shift.type === "open_shift"
                                        ? "text-emerald-700"
                                        : "text-rose-700"
                                    }`}
                                  >
                                    {shift.type === "open_shift"
                                      ? "Open Shift"
                                      : "Dropped By"}
                                  </div>
                                </div>
                                {shift.type !== "open_shift" && (
                                  <div className="flex items-center space-x-1.5 mt-0.5">
                                    <div className="w-5 h-5 bg-slate-200 rounded-full flex items-center justify-center">
                                      <p className="text-slate-600 text-[9px]">
                                        {shift?.employee_drop && getInitials(shift?.employee_drop?.first_name, shift?.employee_drop?.last_name)}
                                      </p>
                                    </div>
                                    <p className="text-slate-500 text-xs">{shift?.employee_drop?.first_name} {shift?.employee_drop?.last_name}</p>
                                  </div>
                                )}
                              </td>
                              <td className="whitespace-nowrap px-3 py-3.5 text-sm">
                                <div className="font-semibold text-slate-900">
                                  {shiftDrop.date ? formatDateReadable(shiftDrop.date) : 'No date'}
                                </div>
                                <div className="text-slate-500 text-xs mt-0.5">
                                  {get_t_str(shiftDrop?.shift_start)} - {get_t_str(shiftDrop?.shift_end)}
                                </div>
                              </td>
                              <td className="whitespace-nowrap px-3 py-3.5 text-sm text-slate-500">
                                {shiftDrop?.station?.name ||
                                 shiftDrop?.role_id?.role_name ||
                                 shiftDrop?.role_id?.role_type?.role_type ||
                                 'No role info'}
                              </td>
                              <td className="whitespace-nowrap px-3 py-3.5 text-sm">
                                <ActionPill
                                  text={getActionDisplay(shift).text}
                                  textColor={getActionDisplay(shift).textColor}
                                  bgColor={getActionDisplay(shift).bgColor}
                                />
                              </td>
                              <td className="relative whitespace-nowrap py-3.5 pl-3 pr-6 text-right text-sm font-medium">
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <div className="border-b border-slate-100"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <EmptyState
            title="History"
            description="No shift pool actions at the moment"
          />
        )}
      </div>
      {selectedShift && (
        <ShiftPoolApprovedDrawer
          isDrawerOpen={isDrawerOpen}
          setDrawerOpen={setDrawerOpen}
          shiftInfo={selectedShift.shiftInfo}
          note={selectedShift.note}
          employeeDropNote={selectedShift.employeeDropNote}
        />
      )}
    </>
  );
}
